import {PropsWithChildren} from 'react';

export function Block(props: PropsWithChildren<Record<string, never>>) {
  return props.children;
}

export default Block;
